import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
export var DropIndicator = function (_a) {
    var dropPosition = _a.dropPosition, dropLevelOffset = _a.dropLevelOffset, indent = _a.indent;
    var style = {};
    switch (dropPosition) {
        case -1:
            style.top = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 1:
            style.bottom = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 0:
            style.bottom = 0;
            style.left = indent;
            break;
    }
    return _jsx(Root, { style: style });
};
var Root = styled('div', {
    name: 'RaDropIndicator',
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var theme = _a.theme;
    return ({
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        backgroundColor: theme.palette.secondary.main,
        height: 2,
    });
});
